// // src/components/ProtectedRoute.jsx
// import { useContext } from "react";
// import { Navigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const ProtectedRoute = ({ children, allowedRoles = [] }) => {
//   const { token, user, loading } = useContext(AuthContext);

//   // fallback to localStorage
//   const finalToken = token || localStorage.getItem("token");
//   let finalUser = user;
//   if (!finalUser) {
//     try {
//       const raw = localStorage.getItem("user");
//       finalUser = raw ? JSON.parse(raw) : null;
//     } catch {
//       finalUser = null;
//     }
//   }

//   if (loading) {
//     return <div className="flex items-center justify-center h-screen">Loading...</div>;
//   }

//   if (!finalToken || !finalUser) {
//     return <Navigate to="/login" replace />;
//   }

//   if (allowedRoles && allowedRoles.length > 0) {
//     const role = (finalUser.role || "").toString().toLowerCase();
//     const allowed = allowedRoles.map((r) => r.toString().toLowerCase());
//     if (!allowed.includes(role)) {
//       return <Navigate to="/login" replace />;
//     }
//   }

//   return children;
// };

// export default ProtectedRoute;

// src/components/ProtectedRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { token, user, loading } = useContext(AuthContext);

  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;

  // if not authenticated -> redirect to login
  if (!token || !user) return <Navigate to="/login" replace />;

  if (allowedRoles && allowedRoles.length > 0) {
    const role = (user.role || "").toString().toLowerCase();
    const allowed = allowedRoles.map((r) => r.toString().toLowerCase());
    if (!allowed.includes(role)) {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
